import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initAdvantagesSlider = () => {
  const sliderEl = document.querySelector(".advantages__carousel");
  if (!sliderEl) return;

  const prevEl = document.querySelector(".advantages__btn--prev");
  const nextEl = document.querySelector(".advantages__btn--next");

  new Swiper(sliderEl, {
    modules: [Keyboard, Mousewheel, Navigation],
    slidesPerView: 1,
    spaceBetween: 56,
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    breakpoints: {
      993: {
        slidesPerView: 4,
        spaceBetween: 56,
      },
    },
  });
};

export default initAdvantagesSlider;
